<template>
  <section class="dialogBind">
    <el-dialog
      :close-on-click-modal="false"
      center
      :title="$t('global.第三方账号绑定')"
      :visible="true"
      width="500px"
      top="30vh"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <div class="container cancel">
        <p v-for="(item,index) in argument.cancelObj&&argument.cancelObj.p" :key="index">{{item}}</p>
        <h5 v-for="(item,index) in argument.cancelObj&&argument.cancelObj.h" :key="index">{{item}}</h5>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="unbinding">{{$t('global.确认解绑')}}</el-button>
        <el-button type="primary" plain @click="handleClose">{{$t('global.暂不解绑')}}</el-button>
        <a href="javascript:;" class="marge" @click="merge">{{$t('global.申请合并这些账号')}}</a>
      </span>
    </el-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    argument: {
      type: Object
    },
    close: {
      type: Function
    }
  },
  created() {},
  methods: {
    unbinding() {
      const url = `/api/user/b/unBindingOtherThird`;
      const params = {
        client: this.argument.client,
        openId: this.argument.openId,
        unionId: this.argument.unionId
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.$message.success(res.message);
          this.handleClose();
          this.$router.push('/manageCenter?step=1')
        }
      });
    },
    handleClose() {
      this.$emit("close");
      this.$router.push('/manageCenter?step=1')
    },
    merge() {
      const url = `/api/user/b/applyThirdAccountMerge`;
      const params = {
        openId: this.argument.openId,
        unionId: this.argument.unionId
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.$message({
            type: "success",
            message: res.message
          });
          this.handleClose();
          this.$router.push('/manageCenter?step=1')
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.el-dialog__body {
  .container {
    width: 100%;

    ul {
      padding: 0 40px 40px;

      li {
        border-bottom: 1px solid #eaebec;
        display: flex;
        flex-direction: row;
        padding: 20px 0 5px;

        .areaCode {
          width: 80px;
        }

        span {
          color: #333;
          line-height: 40px;
          width: 80px;
        }

        input {
          flex: 1;
        }

        .el-form-item {
          flex: 1;
          margin-bottom: 0;

          .el-form-item__content {
            position: relative;

            input {
              border: 0;
            }

            .sendCode {
              position: absolute;
              right: 20px;
              top: 0;
              color: #5f86fc;
            }
          }
        }
      }
    }
  }

  .container.cancel {
    p, h5 {
      color: #333;
      line-height: 20px;
      padding-bottom: 20px;
      font-size: 14px;
    }
  }
}
</style>
<style lang="stylus">
.dialogBind {
  .el-dialog__header {
    border-bottom: 1px solid #eaebec;
  }

  .el-form-item {
    flex: 1;

    .el-form-item__content {
      input {
        border: 0;
        padding: 0;
      }
    }
  }

  .areaCode {
    .el-input--suffix {
      input {
        border: none;
      }
    }

    .el-input--suffix {
      .el-input__suffix-inner {
        .el-select__caret {
          color: #c0c4cc;
          font-size: 14px;
          transition: transform 0.3s;
          transform: rotate(180deg);
          cursor: pointer;

          &:before {
            content: '\e6e1';
          }

          &:after {
            content: '';
            height: 100%;
            width: 0;
            display: inline-block;
            vertical-align: middle;
          }

          &.is-reverse {
            transform: rotate(0deg);
          }
        }
      }
    }
  }

  .el-dialog__footer {
    padding-bottom: 40px;

    .el-button {
      width: 60%;
      height: 40px;
      margin-bottom: 10px;
      margin-left: 0;

      &:not(.is-plain) {
        background: #3664ED;
      }
    }

    .marge {
      display: block;
      color: #3664ED;
      padding: 10px;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/pages/dialog/ThirdBindDialog.vue